import { useMemo } from 'react';

export const useFilterByDate = (dataArr, initialDate, finalDate, compareDatePropName) => {
  const filteredData = useMemo(() => {
    if (initialDate === '' && finalDate === '') {
      return dataArr;
    }

    const endDate = finalDate ? new Date(finalDate) : new Date();
    endDate.setHours(23, 59, 59, 999); // Set the time to 23:59:59.999

    return dataArr.filter((item) => {
      if (typeof item[compareDatePropName] === 'object') {
        const itemDate = item[compareDatePropName].toDate();
        const isAfterInitial = !initialDate || itemDate >= new Date(initialDate);
        const isBeforeFinal = itemDate <= endDate;
        return isAfterInitial && isBeforeFinal;
      }
      return false;
    });
  }, [dataArr, initialDate, finalDate, compareDatePropName]);

  return { filteredData };
};
